module.exports = __webpack_public_path__ + "static/media/ChineduIsagba.68992cf6.jpg";